import moment from '@e3dc-react/shell/Libs/moment'
import { PriceDto } from '../api/dto/power-prices.dto'
import { NullablePowerPrice } from '../types'

/**
 * Transformer to transform api data to useable data for frontend
 */
const powerPriceToModelTransformer = (prices: PriceDto[]): NullablePowerPrice[] => {
  return prices
    .map((_, index) => ({
      price: prices[index].price,
      validFrom: prices[index].validFrom,
      validTo: prices[index].validTo,
    }))
    .sort((a, b) => (moment(a.validFrom).isAfter(moment(b.validFrom)) ? 1 : -1))
}

export default powerPriceToModelTransformer
